// extracted by mini-css-extract-plugin
module.exports = {"altHero":"oj","altProd":"pj","subheading":"qj","subtext":"rj","extrainfo":"sj","copy":"tj","cta":"uj","disabled":"vj"};